import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import {FileManagerService} from '../../main/file-manager/file-manager.service';
import {ProgressBarMode} from '@angular/material/progress-bar';
import {NICEStudioScript} from '../../models/NICE_StudioScript.model';
import {IcDataService} from '../../services/ic-data.service';
import {IcDataStudioScriptsService} from "../../services/ic-data.studio-scripts.service";
import {NICESkill} from "../../models/NICE_Skill.model";
import {JSON2CSVService} from "../../services/JSON2CSV.service";
import {NICEStudioScriptData} from "../../models/NICE_ScriptData.model";
import {NICEPOC} from "../../models/NICE_POC.model";
import {forkJoin} from "rxjs";

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './script-references-dialog.component.html',
    styleUrls: ['./script-references-dialog.component.scss']
})

export class ScriptReferencesDialogComponent implements OnInit {
    totalProcessCount = 0;
    currentProcessIndex = 0;
    processing= false;
    processingFileName: string;
    progressMode: ProgressBarMode = 'determinate';
    references:ScriptReference[] = [];
    scriptMap: Map <number,NICEStudioScript> = new Map();
    skills:NICESkill[]=[];
    scripts:NICEStudioScript[]=[];
    pocs: NICEPOC[] =[];
    private schedules: any[] = [];
    private cancel= false;
    constructor(
        private dialogRef: MatDialogRef<ScriptReferencesDialogComponent>,
        private _icData: IcDataService,
        private _scriptService: IcDataStudioScriptsService,
        private json2csv: JSON2CSVService,
        @Inject(MAT_DIALOG_DATA) public data: SRDataModel
    ) {

    }

    ngOnInit(): void {
        forkJoin({
            scripts: this._scriptService.getStudioScripts(),
            skills: this._icData.getSkills(),
            pocs:this._icData.getPointsOfContact(),
            scheduledScripts: this._scriptService.getScriptSchedules()
        }).subscribe((res) =>{
            this.scripts = res.scripts;
            for (const script of res.scripts) {
                this.scriptMap.set(script.scriptId, script);
            }
            this.skills = res.skills;
            this.pocs =res.pocs;
            this.schedules = res.scheduledScripts.scriptSchedules;
            this.totalProcessCount = this.skills.length + this.scripts.length + this.pocs.length + this.schedules.length;
            }
        );
    }
    findScriptUsages(){
        this.processing= true;
        for(const poc of this.pocs)
        {
            this.processingFileName = poc.ContactDescription;
            this.currentProcessIndex =this.currentProcessIndex + 1;
            if (poc.ScriptName && poc.ScriptName.trim() !=='') {
                this.references.push(new ScriptReference(0, poc.ScriptName, 'PointOfContact', poc.ContactDescription));
            }
        }
        this.getSkillScriptReferences().then(()=>{
                this.getScriptActionUsages().then(()=>{
                    this.getScheduledScripts().then(()=>{
                        if(!this.cancel){
                            this.json2csv.downloadFile(this.json2csv.convertToCSV(this.references, {fields: ['scriptName','usageName','usageLocation']}), 'ScriptReferences');
                            this.dialogRef.close(true);
                        }
                    });
                });
        }
        );
    }
    async getScriptActionUsages(){
        for (const script of this.scripts) {
            this.processingFileName = script.scriptName;
            this.currentProcessIndex =this.currentProcessIndex + 1;
            const scriptData = await this._scriptService.getStudioScript(script.scriptId.toString())
            const parsedScript = new NICEStudioScriptData(scriptData.body);
            if (parsedScript.ScriptContainer.Actions.ActionStruct){
                const scriptActions = parsedScript.ScriptContainer.Actions.ActionStruct.filter(action => (["RUNSUB", "SPAWN", "RUNSCRIPT"].includes(action.Action)));
                for (const scriptAction of scriptActions) {
                    if (scriptAction.Parameters.string[0] && scriptAction.Parameters.string[0].trim() !== '')
                    {
                        this.references.push(new ScriptReference(0, scriptAction.Parameters.string[0], scriptAction.Action, script.scriptName));
                    }
                }
            }
            if(this.cancel) {
                break;
            }
        }
    }

    async getScheduledScripts(){
        for (const schedule of this.schedules) {
            this.processingFileName = schedule.name;
            this.currentProcessIndex =this.currentProcessIndex + 1;
            const scheduleInfo = await this._scriptService.getScriptSchedule(schedule.id);
            //console.log('scheduleInfo',scheduleInfo);
            this.references.push(new ScriptReference(scheduleInfo.script,this.scriptMap.get(scheduleInfo.script)?.scriptName, 'Scheduled Script', scheduleInfo.name));
            if(this.cancel) {
                break;
            }
        }
    }


    async getSkillScriptReferences() {

        for (const skill of this.skills) {
            this.currentProcessIndex = this.currentProcessIndex +1;
            this.processingFileName = skill.skillName;
            if (skill.scriptName && skill.scriptName.trim() !== '') {
                if (skill.isOutbound) {
                    this.references.push(new ScriptReference(skill.scriptId,skill.scriptName, 'OB CustomScript', skill.skillName));
                } else {
                    this.references.push(new ScriptReference(skill.scriptId,skill.scriptName, 'Reskill Script', skill.skillName));
                }
            }
            if (skill.callSuppressionScriptId > 0) {
                this.references.push(new ScriptReference(skill.callSuppressionScriptId,this.scriptMap.get(skill.callSuppressionScriptId)?.scriptName, 'SuppressionScript', skill.skillName));
            }
            if (skill.outboundStrategy === "Personal Connection") {
                const XSSettings = await this._icData.getDialerXSSettings(skill.skillId.toString());
                if (XSSettings.xsScriptID>0){
                    this.references.push(new ScriptReference(XSSettings.xsScriptID,this.scriptMap.get(XSSettings.xsScriptID)?.scriptName, 'XSControl', skill.skillName));
                }
                if (XSSettings.xsCheckinScriptID>0){
                    this.references.push(new ScriptReference(XSSettings.xsCheckinScriptID,this.scriptMap.get(XSSettings.xsCheckinScriptID)?.scriptName, 'XSCheckInScript', skill.skillName));
                }
            }
            if(this.cancel) {
                break;
            }
        }
    }

    getSkyboxAuditUsages(){

    }

    completeProgress(){
        return Math.round((this.currentProcessIndex) * 100 / this.totalProcessCount);
    }

    cancelProcess(): void {
        this.cancel = true;
        this.dialogRef.close(false);
    }
}

export class SRDataModel {
    constructor(
        public mustConfirm= false,
        public overwriteByDefault = false,
    )
    {

    }
}

export class ScriptReference {
    scriptName = '';
    scriptId = '';
    usageName = '';
    usageLocation = '';

    constructor(scriptId,scriptName,usageName,usageLocation)
    {
        this.scriptName = scriptName;
        this.usageName = usageName;
        this.usageLocation = usageLocation;
        this.scriptId = scriptId;
    }
}



